<template>
  <v-container grid-list-md text-xs-center>
    <v-layout row wrap>
      <v-flex xs12 md12>
        <invoice-screen isSummary :invoiceData="invoiceData"/>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import InvoiceScreen from './InvoiceScreen'
export default {
  components: {
    InvoiceScreen
  },
  data () {
    return {
      invoiceData: {
        items: [],
        rate: 2,
        totalAmount: 0,
        buyerId: null
      }
    }
  },
  methods: {
    reset () {
      this.invoiceData = {
        items: [
          {
            type: 'Gold',
            subType: 'Chain',
            weight: 12.45,
            quantity: 2,
            currentValue: 12.34,
            principalValue: 123.2,
            buyerId: this.buyerId
          }, {
            type: 'Silver',
            subType: 'Ring',
            weight: 22.45,
            quantity: 2,
            currentValue: 12.34,
            principalValue: 153.2,
            buyerId: this.buyerId
          }
        ],
        rate: 2,
        totalAmount: 276.4,
        buyerId: this.buyerId
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Buyers/Invoice/ViewInvoice.vue